if (process.env.NODE_ENV === "development") {
  let url = window.location.href
  if (url.indexOf('/page/index.html') == -1) {
    window.location.href = url.replace(url, `${url}page/index.html`);
  }
}

// ---------------------以上勿刪----------------------------
//FESD
import '../fesd/fesd'
import '../../sass/index/index.sass'

//Swiper
import Swiper from 'swiper/js/swiper.js';
//卷軸
import 'jquery.scrollbar/jquery.scrollbar.min.js'
//表單
// import { form } from '../includes/_form'
//其他Methods
import { methods } from '../includes/_methods'


let otherSwiper;

let _home = {
  // section2
  section2Init(){
    let li = $('.section2 li');
    li.each(function(i){
      // 預設第二則+效果
      if(i === 1){
        $(this).addClass('active');
      }
    });
    li.on('mouseenter',function(){
      $(this).siblings().removeClass('active');
      $(this).addClass('active');
    });
  },
  // other
  // other 斷點
  otherBkp(){
    let check = function(){
      if(window.innerWidth <= 1200) return true
    }
    // 手機版啟動 swiper
    if(check()) _swiper.other();
    // 電腦版
    else {
      _home.otherInit();
      _home.otherEf();
      if(otherSwiper !== undefined) otherSwiper.destroy();
    }
  },
  // other 區塊 hover
  otherEf() {
    let block = $('.other .swiper-slide');
    let bg = $('.other .content');
    
    block.on('mouseenter',function(){
      let img = $(this).attr('data-desktop');
      if(!$(this).hasClass('active')){
        $(this).siblings().removeClass('active');
        $(this).addClass('active');
        bg.css('background-image',`url(${img})`);
      }
    });
  },
  // 預設啟動訊息
  otherInit() {
    let block = $('.other .swiper-slide');
    let bg = $('.other .content');

    block.each(function(index){
      if(index == 1){
        let img = $(this).attr('data-desktop');
        $(this).siblings().removeClass('active');
        $(this).addClass('active');
        bg.css('background-image',`url(${img})`);
      }
    });
  },

  // brand
  // brand給左右樣式
  brandType() {
    const typeA = $('.brand .typeA'),
          typeB = $('.brand .typeB');
    typeA.each(function(index){
      if(index%2 !== 0){
        $(this).addClass('reverse');
      }
    });
    typeB.each(function(index){
      if(index%2 !== 0){
        $(this).addClass('reverse');
      }
    })
  },

  // about
  aboutInit() {
    const block = $('.about li'),
          photo = $('.about .photo');
    block.each(function(index){
      if(index == 1){
        let img = $(this).attr('data-img')
        $(this).addClass('active');
        photo.css('background-image', `url(${img})`);
      }
    });
  },
  // about hover
  aboutEf() {
    const block = $('.about li'),
          photo = $('.about .photo');
    block.on('mouseenter',function(){
      let img = $(this).attr('data-img');
      $(this).siblings().removeClass('active');
      $(this).addClass('active');
      photo.css('background-image', `url(${img})`);
    });
  },
  // text animation
  TextAnimation() {
    let bannerTitle = $('.banner-info h2'),
        bannerText = $('.banner-info p');
    bannerTitle.each(function(i,el){
      methods.wordAnimation(el, true, 'random', 0.1, 3)
    });
    // bannerText.each(function(i,el){
    //   methods.wordAnimation(el, true,  0.1, 0.1)
    // });
  },
  all(){
    _home.section2Init();
    _home.otherBkp();
    methods.resize(_home.otherBkp);
    _home.brandType();
    _home.aboutInit();
    _home.aboutEf();
    _home.TextAnimation();
  }
}

// swiper
let _swiper = {
  bannerPage(){
    let len = $('.banner .swiper-slide').length,
        all = $('.banner .swiper-page p.all');
    if(len > 1) all.text(`0${len}`);
    else $('.banner .swiper-page').hide();
    _swiper.banner();
  },
  banner() {
    const setting = {
      on:{
        init: function(){
          methods.getSlidesCount(this);
          let _this = $(this)[0];
          let color = $('.swiper-slide-active .banner-slide').attr('data-color');
          // 設定顏色樣式
          $(_this.params.pagination.el).attr('data-color',color);
          $('.swiper-page').css('color',color);
          // 動畫
          $('.banner .swiper-slide-active').addClass('in');
          // 滑鼠移入訊息暫停播放
          $('.swiper-slide .banner-slide .banner-info').on('mouseenter',function(){
            _this.autoplay.stop();
          }).on('mouseleave',function(){
            _this.autoplay.start();
          });
        },
        slideChangeTransitionStart: function () {
          let now = $('.banner .swiper-page p.now'),
              index = Number($('.banner .swiper-slide-active').attr('data-swiper-slide-index'));
          let _this = $(this)[0];
          let color = $('.swiper-slide-active .banner-slide').attr('data-color');
          // 設定顏色樣式
          $(_this.params.pagination.el).attr('data-color',color);
          $('.swiper-page').css('color',color);
          // 動畫
          $('.banner .swiper-slide-active').siblings().removeClass('in');
          $('.banner .swiper-slide-active').addClass('in');
          // 頁碼
          now.text(`0${index + 1}`);
        },
      },
      autoplay: {
        delay: 5000,
      },
      speed: 800,
      effect: 'fade',
      fadeEffect: {
        crossFade: false
      },
      loop: true,
      lazy: {
        elementClass: 'bg-desktop',
        loadPrevNext: true
      },
      breakpoints: {
        320: {
          lazy: {
            elementClass: 'bg-mobile'
          },
        },
        768: {
          lazy: {
            elementClass: 'bg-desktop'
          },
        }
      },
      pagination: {
        el: '.banner .swiper-pagination',
        clickable: true,
      }
    }
    const banner = new Swiper('.banner .swiper-container', setting)
  },
  other(){
    const setting = {
      on: {
        init() {
          methods.getSlidesCount(this);
          let bg = $('.other .content'),
              active = $('.other .swiper-slide-active');
          active.addClass('active');
          active.siblings().removeClass('active');

          let desktop = $('.other .swiper-slide-active.active').attr('data-desktop'),
              mobile = $('.other .swiper-slide-active.active').attr('data-mobile');

          if(window.innerWidth >= 901 && window.innerWidth <= 1200) bg.css('background-image',`url(${desktop})`);
          else if(window.innerWidth <= 900) bg.css('background-image',`url(${mobile})`);
        },
        slideChangeTransitionStart() {
          let bg = $('.other .content'),
              active = $('.other .swiper-slide-active');
          active.addClass('active');
          active.siblings().removeClass('active');

          let desktop = $('.other .swiper-slide-active.active').attr('data-desktop'),
              mobile = $('.other .swiper-slide-active.active').attr('data-mobile');

          if(window.innerWidth >= 901 && window.innerWidth <= 1200) bg.css('background-image',`url(${desktop})`);
          else if(window.innerWidth <= 900) bg.css('background-image',`url(${mobile})`);
        }
      },
      speed: 1500,
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: '.other .swiper-button-next',
        prevEl: '.other .swiper-button-prev',
      }
    }
    otherSwiper = new Swiper('.other .swiper-container', setting)
  },
  news(){
    const setting = {
      on: {
        init() {
          methods.getSlidesCount(this);
        }
      },
      loop: true,
      autoplay: true,
      speed: 1200,
      spaceBetween: 0,
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1
        },
        1201: {
          slidesPerView: 2
        }
      },
      pagination: {
        el: '.news .swiper-pagination',
        clickable: true,
      },
    }
    const newsSwiper = new Swiper('.news .swiper-container', setting)
  },

  all() {
    _swiper.bannerPage();
    _swiper.news();
  }
}

$(function () {
  _swiper.all();
  _home.all();
})
